import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-16 md:py-20 px-4" data-id="element-147" data-mp="4vrzlvp3q9pt">
      <div className="max-w-4xl mx-auto" data-id="element-148" data-mp="9umkd36mq8ck">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-149" data-mp="9srwbg02a049">
          <div className="grid md:grid-cols-[auto,1fr] gap-7 items-center" data-id="element-150" data-mp="sm5m76ox3gd0">
            <div className="flex justify-center md:justify-start" data-id="element-151" data-mp="xk72xkyvf3lb">
              <div className="relative w-32 h-32 md:w-40 md:h-40 rounded-full bg-bg-warm border-4 border-rose flex flex-col items-center justify-center shadow-lg" data-id="element-152" data-mp="12j0j5l5jl8p6">
                <ShieldCheckIcon className="w-10 h-10 text-rose mb-1" data-id="element-153" data-mp="17id39y5141o2" />
                <div className="font-serif text-2xl font-bold text-ink leading-none" data-id="element-154" data-mp="25syjqqmtreg6">
                  7 días
                </div>
                <div className="text-[10px] tracking-widest text-rose font-bold mt-1" data-id="element-155" data-mp="20rj2l9nrps32">
                  GARANTÍA
                </div>
              </div>
            </div>
            <div className="text-center md:text-left" data-id="element-156" data-mp="1rth3iznlh9if">
              <div className="text-xs font-bold text-rose tracking-widest mb-3 uppercase" data-id="element-157" data-mp="2oiewccbsaxcy">
                🛡️ Garantía 7 días — Sin preguntas
              </div>
              <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-3 uppercase tracking-tight" data-id="element-158" data-mp="2jk3ou88yoyxw">
                Probalo sin{' '}
                <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-159" data-mp="2arjn2yxdie8u">
                  riesgo
                </span>
              </h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-160" data-mp="37a7ibmsfrib6">
                Abrís el ebook. Lo aplicás en tu vida. Si en 7 días no es lo que
                esperabas, te devolvemos el 100% de tu dinero. Sin formularios.
                Sin trámites. Sin preguntas.
              </p>
              <p className="text-sm text-muted mt-3" data-id="element-161" data-mp="15ifhx3alccvv">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}